export default __webpack_public_path__ + "static/media/AI_human_computer.bcd45274.svg";